import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from '@commons/breadcrumb/breadcrumb/breadcrumb.component';
import { SvgIconModule } from '@commons/svg-icon/svg-icon.module';
import { I18nDomainModule } from '@domains/job/i18n-domain/i18n-domain.module';

@NgModule({
  declarations: [BreadcrumbComponent],
  imports: [CommonModule, RouterModule, SvgIconModule, I18nDomainModule],
  exports: [BreadcrumbComponent],
})
export class BreadcrumbModule {}
